import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  TextField,
  DialogActions,
  FormControl,
  FormControlLabel,
  Checkbox,
  Button,
  Box,
  Skeleton,
  IconButton,
} from "@material-ui/core";
import { withStyles, makeStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { Formik } from "formik";
import CloseIcon from "@material-ui/icons/CloseRounded";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import AdminRoleSelect from "../../select/adminRoleSelect";

const useStyles = makeStyles((theme) => ({
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
}));

const Accordion = withStyles({
  root: {
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    margin: "0px 0",
    "&$expanded": {
      margin: "0px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: "unset",
  },
}))(MuiAccordionDetails);

export default function AdminRoleDialogComponent({
  open,
  handleSubmit,
  onAdminRoleDialogCloseClick,
  isLoading,
  isUpdating,
}) {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={onAdminRoleDialogCloseClick}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth
    >
      <Formik
        initialValues={{
          adminRole: [],
        }}
        enableReinitialize
        // validationSchema={Yup.object().shape({
        //   branch: Yup.mixed().required('Required')
        // })}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <DialogTitle id="scroll-dialog-title">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <IconButton
                  size="small"
                  color="inherit"
                  onClick={onAdminRoleDialogCloseClick}
                  style={{ padding: 0 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </DialogTitle>
            <DialogContent dividers className={classes.scrollContainer}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box flexGrow={1}>
                  <Typography variant="body2" className={classes.labelText}>
                    Admin Role
                  </Typography>
                </Box>
              </Box>
              <Box className={classes.accessBox} mt={2}>
                {isLoading ? (
                  <>
                    <Skeleton variant="text" animation="wave" height={25} />
                    <Skeleton variant="text" animation="wave" height={25} />
                    <Skeleton variant="text" animation="wave" height={25} />
                    <Skeleton variant="text" animation="wave" height={25} />
                  </>
                ) : (
                  <AdminRoleSelect
                    placeholder="Select Admin Role"
                    selectedAdminRole={formik.values.adminRole ?? ''}
                    handleAdminRoleChange={(value) => {
                      formik.setFieldValue('adminRole', value);
                    }}
                  />
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                variant="text"
                type="button"
                disabled={isUpdating}
                onClick={onAdminRoleDialogCloseClick}
                style={{ color: "black" }}
              >
                Cancel
              </Button>
              <Button variant="contained" type="submit" disabled={isUpdating}>
                Save
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
